import store from '@/store';
import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';
import Cookies from 'js-cookie';
import { auth0 } from '@/utils/auth0';
import { PAYMENTS_TRACKING_PARAMS } from '@/data/payments';
import { RouteNames } from '@/data/routes';
import AuthLoginPage from '@/pages/auth/AuthLoginPage.vue';
import AuthPasswordResetPage from '@/pages/auth/AuthPasswordResetPage.vue';
import AuthErrorPage from '@/pages/auth/AuthErrorPage.vue';
import { LocalStorage, LocalStorageKeys } from '@/utils/local-storage';
import { RouteLocation } from 'vue-router';
import { createRoutes } from '@/utils/router-helper';
import { shutdownStatsig } from '@/utils/init-statsig';
import AuthLinkAccountsPage from '@/pages/auth/AuthLinkAccountsPage.vue';

const signupExperiments = ['ctrl', 'ex-august-2025'];

export default createRoutes(
  // This is to be sure that the user is redirected with the required params in order to show the "signup" tab on the auth0 component
  {
    path: '/signup',
    name: RouteNames.AUTH.SIGNUP,
    beforeEnter: (to: RouteLocation) => {
      if (
        Object.keys(to.query).some((param) =>
          PAYMENTS_TRACKING_PARAMS.includes(param),
        )
      ) {
        LocalStorage.setItem(LocalStorageKeys.SIGNUP_PARAMS, to.query);
      }

      const { location } = window;
      const experiment =
        signupExperiments[Math.floor(Math.random() * signupExperiments.length)];
      const params = new URLSearchParams(location.search);
      params.set('initialScreen', 'signUp');
      params.set('cb-ex', experiment);

      location.href = `${location.origin}/?${params.toString()}`;
    },
  },
  {
    path: '/login',
    name: RouteNames.AUTH.LOGIN,
    component: AuthLoginPage,
    beforeEnter: (to: RouteLocation, from: RouteLocation) => {
      if (to.query.error) {
        return { name: RouteNames.AUTH.ERROR, query: to.query };
      }
      // redirect to /home in order to be consistent with deployed environments, see `_redirects`
      return { name: RouteNames.HOME.INDEX, query: to.query };
    },
  },
  {
    path: '/logout',
    name: RouteNames.AUTH.LOGOUT,
    beforeEnter: async (to: RouteLocation, from: RouteLocation) => {
      shutdownStatsig();

      // Using setTimeout to ensure the state is reset
      // after the next rendering cycle
      setTimeout(() => {
        store.commit('USER_LOGOUT');
        store.commit('RESET_SIGNUP_STATE');
      });
      analytics.track(SEGMENT_EVENTS.fe_logout);
      Cookies.remove('cb-user-email', { path: '/' });

      await auth0.logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    },
  },
  {
    path: '/password-reset',
    name: RouteNames.AUTH.PASSWORD_RESET,
    component: AuthPasswordResetPage,
  },
  {
    path: '/error',
    name: RouteNames.AUTH.ERROR,
    component: AuthErrorPage,
    props: (route: any) => ({
      errorMessage: route.query?.error_description,
    }),
  },
  {
    path: '/link-accounts',
    name: RouteNames.AUTH.LINK_ACCOUNTS,
    component: AuthLinkAccountsPage,
    props: (route: any) => ({
      linkAccountToken: route.query?.link_account_token,
    }),
  },
);
